import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../components/common/sidebar/SideBar";
import Header from "../components/common/header/Header";

import Footer from "./common/footer/Footer";

import ForgetPassword from "./pages/login/ForgetPassword";
import ResetPassword from "./pages/login/ResetPassword";
import ProtectedRoute from "./ProtectedRoute";
import "./layout.css";

import HeaderWithoutLogin from "./common/header/HeaderWithoutLogin";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import Login from "./pages/login/Login";

//================================USERS==================================
import Users from "./pages/user-management/users/Users";
//-----------------------------------------------------------------------

//===================================PARTNERS======================================
import SupplyPartners from "./pages/supply-management/partners/Partners";
import DemandPartner from "./pages/demand-management/DemandPartner";
import AgencyPartner from "./pages/agency-management/AgencyPartner";
import BrandPartner from "./pages/brand-management/BrandPartner";
//----------------------------------------------------------------------------------

//===================================TOOLS==========================================
import Deals from "./pages/tools/deals";
import MapDeals from "./pages/tools/map-deals";
import SegmentRequest from "./pages/tools/segment-request";
import CompareCsv from "./pages/tools/compare-csv";
import CompareDeal from "./pages/tools/compare-deal";
//----------------------------------------------------------------------------------

//===================================ANALYTICS======================================
import AgencyOverview from "./pages/dashboard/agency-overview";
import HeatMap from "./pages/heatmap/HeatMap";
//----------------------------------------------------------------------------------

//===================================DASHOARD======================================
import Overview from "./pages/dashboard/overview";
import DemandOverview from "./pages/dashboard/demand-overview";
import BrandOverview from "./pages/dashboard/brand-overview";
//----------------------------------------------------------------------------------

//================================PMP SETUP GUIDE==================================
import DV360 from "./pages/pmp/DV360";
import Ttd from "./pages/pmp/ttd/ttd";
import Amazon from "./pages/pmp/amazon/amazon";
//----------------------------------------------------------------------------------

//===================================SEGMENTS======================================
import DataArchitecture from "./pages/segments/data-architecture/DataArchitecture";
import ProductSpine from "./pages/segments/product-spine/ProductSpine";
import AudienceSegments from "./pages/segments/audience-segments/AudienceSegments";
import Dsp from "./pages/segments/segments-management/dsp/Dsp";
import Geo from "./pages/segments/segments-management/geo/Geo";
import Segments from "./pages/segments/segments-management/segments/Segments";
import Reach from "./pages/segments/segments-management/reach/Reach";
import Publishers from "./pages/segments/segments-management/publishers/Publishers";
//----------------------------------------------------------------------------------

//===================================AI-MANAGEMENT==================================
import AiSuggestions from "./pages/ai-management/aiSuggestions/AiSuggestions";
import Suggessions from "./pages/ai-management/suggestions/Suggestions";
import CreateTag from "./pages/ai-management/create-tag/CreateTag";
//----------------------------------------------------------------------------------

//===================================AUTOMATION HUB==================================
import SiteApp from "./pages/ai-management/site-app";
import SiteExpansion from "./pages/ai-management/site-expansion";
import PublisherSites from "./pages/ai-management/publisher-sites";

//----------------------------------------------------------------------------------

//===================================INNOVATION ADS==================================
import InnovationAds from "./pages/innovation-ads";
import QrCodeConfigure from "./pages/innovation-ads/qr-code";
import ShoppableConfigure from "./pages/innovation-ads/shoppable";

//----------------------------------------------------------------------------------

const brandmoSubdomainName = process.env.REACT_APP_BRANDMOSUBDOMAIN;
const brandmoId = process.env.REACT_APP_BRANDMOUSERID;
// Get subdomain (adjust if hosted on brandmo)
const hostname = window.location.hostname;
const subdomain = hostname.includes(brandmoSubdomainName)
  ? brandmoSubdomainName
  : hostname.split(".")[0];

//console.log("==========LAyout=============")
//console.log(subdomain)
//console.log(brandmoSubdomainName)
//console.log("===========LAyout End============")

const Layout = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userType, setUserType] = useState(null);
  const [brandAccess, setBrandAccess] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const checkUser = () => {
      const token = localStorage.getItem("accessToken");
      const role = localStorage.getItem("role");

      if (token) {
        setIsLogin(true);
        setRole(role);
      }

      setIsLoading(false);
    };

    checkUser();
  }, []);
  useEffect(() => {
    const role = localStorage.getItem("role");
    const brandAccess = localStorage.getItem("brand_access");
    setRole(role);
    setBrandAccess(brandAccess);
  }, []);

  useEffect(() => {
    const savedSidebarState = localStorage.getItem("sidebarOpen");
    if (savedSidebarState !== null) {
      setSidebarOpen(JSON.parse(savedSidebarState));
    }
  }, []);

  const setIsLoginHandler = (val) => setIsLogin(val);

  const logOutHandler = () => {
    setIsLogin(false);
    localStorage.removeItem("accessToken");
    localStorage.removeItem("role");
    localStorage.removeItem("brand_access");
  };

  const toggleSidebar = () => {
    const newSidebarState = !sidebarOpen;
    setSidebarOpen(newSidebarState);
    localStorage.setItem("sidebarOpen", JSON.stringify(newSidebarState));
  };

  if (isLoading) return <div>Loading...</div>;

  console.log("==========LAyout=============");
  console.log(subdomain);
  console.log(brandmoSubdomainName);
  console.log("===========LAyout End============");

  // 🚨 If it's the promo subdomain — render minimal public routes only
  if (subdomain === brandmoSubdomainName) {
    return (
      <BrowserRouter>
        <MantineProvider withGlobalStyles withNormalizeCSS>
          <Sidebar isSidebarOpen={sidebarOpen} />
          <HeaderWithoutLogin
            isLogout={logOutHandler}
            isSidebar={toggleSidebar}
          />
          <div
            className={`right-section ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
          >
            <div className="inner-content">
              <Routes>
                <Route
                  path="/data-architecture"
                  element={<DataArchitecture />}
                />
                <Route path="/product-spine" element={<ProductSpine />} />
                <Route
                  path="/audience-segments"
                  element={<AudienceSegments />}
                />
                <Route path="/tasha" element={<AiSuggestions />} />
                <Route
                  path="*"
                  element={<Navigate to="/audience-segments" replace />}
                />
              </Routes>
            </div>
            <Footer />
          </div>
        </MantineProvider>
      </BrowserRouter>
    );
  }
  console.log(userType + "userType");
  // 🌐 Main Application (authenticated or login-based)
  return (
    <BrowserRouter>
      <MantineProvider withGlobalStyles withNormalizeCSS>
        {isLogin ? (
          <>
            <Sidebar isSidebarOpen={sidebarOpen} />
            <Header isLogout={logOutHandler} isSidebar={toggleSidebar} />
            <div
              className={`right-section ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
            >
              <div className="inner-content">
                <Routes>
                  {/* =================================== SEGMENTS  =================================== */}
                  <Route
                    path="/data-architecture"
                    element={<DataArchitecture />}
                  />
                  <Route path="/product-spine" element={<ProductSpine />} />
                  <Route
                    path="/data-architecture"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "client",
                          "sales_user",
                          "admin",
                          "super_admin",
                          "demo",
                        ]}
                      >
                        <DataArchitecture />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/product-spine"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "client",
                          "sales_user",
                          "admin",
                          "super_admin",
                          "demo",
                        ]}
                      >
                        <ProductSpine />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/audience-segments"
                    element={<AudienceSegments />}
                  />
                  <Route
                    path="/dsp"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin"]}>
                        <Dsp />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/geo"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin"]}>
                        <Geo />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/segments"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin"]}>
                        <Segments />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/reach"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin"]}>
                        <Reach />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/publishers"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin"]}>
                        <Publishers />
                      </ProtectedRoute>
                    }
                  />
                  {/*  =================================== DASHBOARD  =================================== */}
                  <Route
                    path="/supply-overview"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "client",
                          "sales_user",
                          "admin",
                          "super_admin",
                          "demo",
                        ]}
                      >
                        <Overview />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/supply-overview/:clientId"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "client",
                          "sales_user",
                          "admin",
                          "super_admin",
                          "demo",
                        ]}
                      >
                        <Overview />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/demand-overview"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "sales_user",
                          "demand",
                          "admin",
                          "super_admin",
                        ]}
                      >
                        <DemandOverview />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/demand-overview/:demandId"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "sales_user",
                          "demand",
                          "admin",
                          "super_admin",
                        ]}
                      >
                        <DemandOverview />
                      </ProtectedRoute>
                    }
                  />
                  {(role === "sales_user" ||
                    role === "admin" ||
                    role === "super_admin" ||
                    role === "demo" ||
                    brandAccess) && (
                    <>
                      <Route
                        path="/brand-overview"
                        element={
                          <ProtectedRoute
                            allowedRoles={[
                              "demand",
                              "client",
                              "sales_user",
                              "admin",
                              "super_admin",
                              "demo",
                            ]}
                          >
                            <BrandOverview />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/brand-overview/:clientId"
                        element={
                          <ProtectedRoute
                            allowedRoles={[
                              "demand",
                              "client",
                              "sales_user",
                              "admin",
                              "super_admin",
                              "demo",
                            ]}
                          >
                            <BrandOverview />
                          </ProtectedRoute>
                        }
                      />
                    </>
                  )}
                  <Route
                    path="/agency-overview"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "sales_user",
                          "admin",
                          "super_admin",
                          "demo",
                        ]}
                      >
                        <AgencyOverview />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/agency-overview/:clientId"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "sales_user",
                          "admin",
                          "super_admin",
                          "demo",
                        ]}
                      >
                        <AgencyOverview />
                      </ProtectedRoute>
                    }
                  />
                  {/*  =================================== PMP SETUP GUIDE  =================================== */}
                  <Route
                    path="/dv360"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "client",
                          "sales_user",
                          "admin",
                          "super_admin",
                          "demo",
                        ]}
                      >
                        <DV360 />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/ttd"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "client",
                          "sales_user",
                          "admin",
                          "super_admin",
                          "demo",
                        ]}
                      >
                        <Ttd />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/amazon"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "client",
                          "sales_user",
                          "admin",
                          "super_admin",
                          "demo",
                        ]}
                      >
                        <Amazon />
                      </ProtectedRoute>
                    }
                  />
                  {/*  =================================== USERS  =================================== */}
                  <Route
                    path="/users"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin"]}>
                        <Users />
                      </ProtectedRoute>
                    }
                  />
                  {/*  =================================== PARTNERS =============================================== */}
                  <Route
                    path="/supplypartners"
                    element={
                      <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
                        <SupplyPartners />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/demand-partners"
                    element={
                      <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
                        <DemandPartner />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/agency-partners"
                    element={
                      <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
                        <AgencyPartner />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/brand-partners"
                    element={
                      <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
                        <BrandPartner />
                      </ProtectedRoute>
                    }
                  />
                  {/*  =================================== AI-MANAGEMENT  =================================== */}
                  <Route
                    path="/suggestions"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin"]}>
                        <Suggessions />
                      </ProtectedRoute>
                    }
                  />
                  

                  <Route
                    path="/create-tag"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin","admin","demo","client","sales_user"]}>
                        <CreateTag />
                      </ProtectedRoute>
                    }
                  />

                  
                  <Route
                    path="/site-app"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin","admin","demo","client","sales_user"]}>
                        <SiteApp />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/site-expansion"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin","admin","demo","client","sales_user"]}>
                        <PublisherSites />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/publisher-sites"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin","admin","demo","client","sales_user"]}>
                        <PublisherSites />
                      </ProtectedRoute>
                    }
                  />

                  {/*  =================================== INNOVATION ADS  =================================== */}
                  <Route
                    path="/innovation-ads"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin","admin","demo","client","sales_user"]}>
                        <InnovationAds />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/innovation-ads/qr-code"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin","admin","demo","client","sales_user"]}>
                        <QrCodeConfigure />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/innovation-ads/shoppable"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin","admin","demo","client","sales_user"]}>
                        <ShoppableConfigure />
                      </ProtectedRoute>
                    }
                  />
                  {/*  =================================== ANALYTICS  =================================== */}
                  <Route
                    path="/heatmap"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "sales_user",
                          "admin",
                          "super_admin",
                          "demo",
                        ]}
                      >
                        <HeatMap />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/tasha"
                    element={
                      <ProtectedRoute
                        allowedRoles={[
                          "demand",
                          "client",
                          "sales_user",
                          "admin",
                          "super_admin",
                          "demo",
                        ]}
                      >
                        <AiSuggestions />
                      </ProtectedRoute>
                    }
                  />
                  {/*  =================================== TOOLS  =================================== */}
                  <Route
                    path="/compare-csv"
                    element={
                      <ProtectedRoute allowedRoles={["super_admin"]}>
                        <CompareCsv />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/deals"
                    element={
                      <ProtectedRoute
                        allowedRoles={["sales_user", "admin", "super_admin"]}
                      >
                        <Deals />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/deals/:id"
                    element={
                      <ProtectedRoute
                        allowedRoles={["sales_user", "admin", "super_admin"]}
                      >
                        <Deals />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/map-deals"
                    element={
                      <ProtectedRoute
                        allowedRoles={["sales_user", "admin", "super_admin"]}
                      >
                        <MapDeals />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/segment-request"
                    element={
                      <ProtectedRoute
                        allowedRoles={["sales_user", "admin", "super_admin"]}
                      >
                        <SegmentRequest />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/compare-deal"
                    element={
                      <ProtectedRoute
                        allowedRoles={["sales_user", "admin", "super_admin"]}
                      >
                        <CompareDeal />
                      </ProtectedRoute>
                    }
                  />
                  {/*  =================================== WITHOUT LOGIN  =================================== */}
                  <Route
                    path="/login"
                    element={
                      <Navigate
                        to={
                          role === "demand"
                            ? "/demand-overview"
                            : role === "brand"
                              ? "/brand-overview"
                              : "/supply-overview"
                        }
                        replace
                      />
                    }
                  />{" "}
                  <Route
                    path="*"
                    element={
                      <Navigate
                        to={
                          userType === "demand"
                            ? "/demand-overview"
                            : userType == "brand"
                              ? "/brand-overview"
                              : "/supply-overview"
                        }
                        replace
                      />
                    }
                  />
                </Routes>
              </div>
              <Footer />
            </div>
          </>
        ) : (
          <Routes>
            <Route
              path="/login"
              element={<Login setLogin={setIsLoginHandler} />}
            />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route
              path="/audience-segments"
              element={
                <>
                  <HeaderWithoutLogin />
                  <br />
                  <br />
                  <br />
                  <AudienceSegments />
                  <br />
                  <br />
                  <br />
                  <Footer />
                </>
              }
            />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        )}
      </MantineProvider>
    </BrowserRouter>
  );
};

export default Layout;
